import video001 from "../assets/clips/001encoded.mp4";
import video002 from "../assets/clips/002encoded.mp4";
import video003 from "../assets/clips/003encoded.mp4";
import video004 from "../assets/clips/004encoded.mp4";
import video005 from "../assets/clips/005encoded.mp4";
import video006 from "../assets/clips/006encoded.mp4";
import video007 from "../assets/clips/007encoded.mp4";
import video008 from "../assets/clips/008encoded.mp4";
import video009 from "../assets/clips/009encoded.mp4";
import video010 from "../assets/clips/010encoded.mp4";
import video011 from "../assets/clips/011encoded.mp4";
import video012 from "../assets/clips/012encoded.mp4";
import video013 from "../assets/clips/013encoded.mp4";
import video014 from "../assets/clips/014encoded.mp4";
import video015 from "../assets/clips/015encoded.mp4";
import video016 from "../assets/clips/016encoded.mp4";

import video001mobile from "../assets/clips/mobile/001encoded-mobile.mp4";
import video002mobile from "../assets/clips/mobile/002encoded-mobile.mp4";
import video003mobile from "../assets/clips/mobile/003encoded-mobile.mp4";
import video004mobile from "../assets/clips/mobile/004encoded-mobile.mp4";
import video005mobile from "../assets/clips/mobile/005encoded-mobile.mp4";
import video006mobile from "../assets/clips/mobile/006encoded-mobile.mp4";
import video007mobile from "../assets/clips/mobile/007encoded-mobile.mp4";
import video008mobile from "../assets/clips/mobile/008encoded-mobile.mp4";
import video009mobile from "../assets/clips/mobile/009encoded-mobile.mp4";
import video010mobile from "../assets/clips/mobile/010encoded-mobile.mp4";
import video011mobile from "../assets/clips/mobile/011encoded-mobile.mp4";
import video012mobile from "../assets/clips/mobile/012encoded-mobile.mp4";
import video013mobile from "../assets/clips/mobile/013encoded-mobile.mp4";
import video014mobile from "../assets/clips/mobile/014encoded-mobile.mp4";
import video015mobile from "../assets/clips/mobile/015encoded-mobile.mp4";
import video016mobile from "../assets/clips/mobile/016encoded-mobile.mp4";
import video017mobile from "../assets/clips/mobile/017encoded-mobile.mp4";
import video018mobile from "../assets/clips/mobile/018encoded-mobile.mp4";
import video019mobile from "../assets/clips/mobile/019encoded-mobile.mp4";
import video020mobile from "../assets/clips/mobile/020encoded-mobile.mp4";
import video021mobile from "../assets/clips/mobile/021encoded-mobile.mp4";
import video022mobile from "../assets/clips/mobile/022encoded-mobile.mp4";
import video023mobile from "../assets/clips/mobile/023encoded-mobile.mp4";

export const constant = 80;
export const mobileConstant = 130;
// export const mobileConstant = 200

const heightCalculation = (duration, multiplier = 0) =>
  duration * constant + multiplier;

const mobileHeightCalculation = (mobileDuration, multiplier = 0) =>
  mobileDuration * mobileConstant + multiplier;

const durations = [
  30.03, 22.4, 25.7, 17.23, 15.53,

  24.13, 0.85, 28.96,
  // 23.87,
  // 30.02,

  17.16, 34.63, 23.97, 28.67, 12.22,

  108.36, 0.97, 28.66,
  // 108.48,
  // 21.68,

  34.23, 19.23,
];

const mobileDurations = [
  12.02, 1.0, 2.0, 4.1, 3.4, 2.0, 6.5, 3.07, 4.03, 1.08, 3.43, 1.2, 2.3, 14.45,
  31.63, 23.83, 28.77, 11.93, 34.52, 4.15, 6.0, 7.85, 6.72,
];

const heightOffsets = [
  0, 2800, 2000, 0, 0, 300, 1700, 2200, 0, 0, 0, 0, 0, 1200, 1500, 0, 500, 0,
];

// const mobileHeightOffsets = [
//   0, 0, 0, 2000, 2700, 1000, 0, 0, 0, 2000, 0, 1650, 800, 0, 0, 0, 0, 0, 1500,
//   2000, 0, 0, 0,
// ];
const mobileHeightOffsets = [
  0, 0, 0, 2000, 5000, 1000, 0, 0, 0, 2000, 0, 5000, 1000, 0, 0, 0, 0, 0, 1500,
  2000, 0, 0, 0,
];

export const videos = [
  {
    src: video001,
    duration: durations[0],
    height: heightCalculation(durations[0]),
    heightOffset: heightOffsets[0],
  },
  {
    src: video002,
    duration: durations[1],
    height: heightCalculation(durations[1]),
    heightOffset: heightOffsets[1],
  },
  {
    src: video003,
    duration: durations[2],
    height: heightCalculation(durations[2]),
    heightOffset: heightOffsets[2],
  },
  {
    src: video004,
    duration: durations[3],
    height: heightCalculation(durations[3]),
    heightOffset: heightOffsets[3],
  },
  {
    src: video005,
    duration: durations[4],
    height: heightCalculation(durations[4]),
    heightOffset: heightOffsets[4],
  },
  {
    src: video006,
    duration: durations[5],
    height: heightCalculation(durations[5]),
    heightOffset: heightOffsets[5],
  },
  {
    src: video007,
    duration: durations[6],
    height: heightCalculation(durations[6]),
    heightOffset: heightOffsets[6],
  },
  {
    src: video008,
    duration: durations[7],
    height: heightCalculation(durations[7]),
    heightOffset: heightOffsets[7],
  },
  {
    src: video009,
    duration: durations[8],
    height: heightCalculation(durations[8]),
    heightOffset: heightOffsets[8],
  },
  {
    src: video010,
    duration: durations[9],
    height: heightCalculation(durations[9]),
    heightOffset: heightOffsets[9],
  },
  {
    src: video011,
    duration: durations[10],
    height: heightCalculation(durations[10]),
    heightOffset: heightOffsets[10],
  },
  {
    src: video012,
    duration: durations[11],
    height: heightCalculation(durations[11]),
    heightOffset: heightOffsets[11],
  },
  {
    src: video013,
    duration: durations[12],
    height: heightCalculation(durations[12]),
    heightOffset: heightOffsets[12],
  },
  {
    src: video014,
    duration: durations[13],
    height: heightCalculation(durations[13]),
    heightOffset: heightOffsets[13],
  },
  {
    src: video015,
    duration: durations[14],
    height: heightCalculation(durations[14]),
    heightOffset: heightOffsets[14],
  },
  {
    src: video016,
    duration: durations[15],
    height: heightCalculation(durations[15]),
    heightOffset: heightOffsets[15],
  },
];

export const mobileVideos = [
  {
    src: video001mobile,
    duration: mobileDurations[0],
    height: mobileHeightCalculation(mobileDurations[0]),
    heightOffset: mobileHeightOffsets[0],
  },
  {
    src: video002mobile,
    duration: mobileDurations[1],
    height: mobileHeightCalculation(mobileDurations[1]),
    heightOffset: mobileHeightOffsets[1],
  },
  {
    src: video003mobile,
    duration: mobileDurations[2],
    height: mobileHeightCalculation(mobileDurations[2]),
    heightOffset: mobileHeightOffsets[2],
  },
  {
    src: video004mobile,
    duration: mobileDurations[3],
    height: mobileHeightCalculation(mobileDurations[3]),
    heightOffset: mobileHeightOffsets[3],
  },
  {
    src: video005mobile,
    duration: mobileDurations[4],
    height: mobileHeightCalculation(mobileDurations[4]),
    heightOffset: mobileHeightOffsets[4],
  },
  {
    src: video006mobile,
    duration: mobileDurations[5],
    height: mobileHeightCalculation(mobileDurations[5]),
    heightOffset: mobileHeightOffsets[5],
  },
  {
    src: video007mobile,
    duration: mobileDurations[6],
    height: mobileHeightCalculation(mobileDurations[6]),
    heightOffset: mobileHeightOffsets[6],
  },
  {
    src: video008mobile,
    duration: mobileDurations[7],
    height: mobileHeightCalculation(mobileDurations[7]),
    heightOffset: mobileHeightOffsets[7],
  },
  {
    src: video009mobile,
    duration: mobileDurations[8],
    height: mobileHeightCalculation(mobileDurations[8]),
    heightOffset: mobileHeightOffsets[8],
  },
  {
    src: video010mobile,
    duration: mobileDurations[9],
    height: mobileHeightCalculation(mobileDurations[9]),
    heightOffset: mobileHeightOffsets[9],
  },
  {
    src: video011mobile,
    duration: mobileDurations[10],
    height: mobileHeightCalculation(mobileDurations[10]),
    heightOffset: mobileHeightOffsets[10],
  },
  {
    src: video012mobile,
    duration: mobileDurations[11],
    height: mobileHeightCalculation(mobileDurations[11]),
    heightOffset: mobileHeightOffsets[11],
  },
  {
    src: video013mobile,
    duration: mobileDurations[12],
    height: mobileHeightCalculation(mobileDurations[12]),
    heightOffset: mobileHeightOffsets[12],
  },
  {
    src: video014mobile,
    duration: mobileDurations[13],
    height: mobileHeightCalculation(mobileDurations[13]),
    heightOffset: mobileHeightOffsets[13],
  },
  {
    src: video015mobile,
    duration: mobileDurations[14],
    height: mobileHeightCalculation(mobileDurations[14]),
    heightOffset: mobileHeightOffsets[14],
  },
  {
    src: video016mobile,
    duration: mobileDurations[15],
    height: mobileHeightCalculation(mobileDurations[15]),
    heightOffset: mobileHeightOffsets[15],
  },
  {
    src: video017mobile,
    duration: mobileDurations[16],
    height: mobileHeightCalculation(mobileDurations[16]),
    heightOffset: mobileHeightOffsets[16],
  },
  {
    src: video018mobile,
    duration: mobileDurations[17],
    height: mobileHeightCalculation(mobileDurations[17]),
    heightOffset: mobileHeightOffsets[17],
  },
  {
    src: video019mobile,
    duration: mobileDurations[18],
    height: mobileHeightCalculation(mobileDurations[18]),
    heightOffset: mobileHeightOffsets[18],
  },
  {
    src: video020mobile,
    duration: mobileDurations[19],
    height: mobileHeightCalculation(mobileDurations[19]),
    heightOffset: mobileHeightOffsets[19],
  },
  {
    src: video021mobile,
    duration: mobileDurations[20],
    height: mobileHeightCalculation(mobileDurations[20]),
    heightOffset: mobileHeightOffsets[20],
  },
  {
    src: video022mobile,
    duration: mobileDurations[21],
    height: mobileHeightCalculation(mobileDurations[21]),
    heightOffset: mobileHeightOffsets[21],
  },
  {
    src: video023mobile,
    duration: mobileDurations[22],
    height: mobileHeightCalculation(mobileDurations[22]),
    heightOffset: mobileHeightOffsets[22],
  },
];

export const heightsSum = videos.reduce((prev, curr) => prev + curr.height, 0);
export const heightOffsetsSum = videos.reduce(
  (prev, curr) => prev + curr.heightOffset,
  0
);

export const mobileHeightsSum = mobileVideos.reduce(
  (prev, curr) => prev + curr.height,
  0
);
export const mobileHeightOffsetsSum = mobileVideos.reduce(
  (prev, curr) => prev + curr.heightOffset,
  0
);
